import {JJ_SESSION_STORAGE} from '../constants/constants';
import {
  getDataFromSessionStorage,
  removeValueFromSessionStorage,
} from './sessionStorage.helper';

export const sanitiseDiscountCode = code => {
  if (!code || typeof code !== 'string') {
    return null;
  }
  const cleaned = code.trim().toUpperCase();
  return cleaned || null;
};

export const getStoredDiscountCode = () => {
  try {
    return (
      sanitiseDiscountCode(
        getDataFromSessionStorage(JJ_SESSION_STORAGE.DISCOUNT_CODE)
      ) || ''
    );
  } catch (e) {
    return '';
  }
};

export const clearStoredDiscountCode = () => {
  try {
    removeValueFromSessionStorage(JJ_SESSION_STORAGE.DISCOUNT_CODE);
  } catch (e) {
    // sessionStorage unavailable — nothing to clear
  }
};
